import type { Bookmark, Folder } from '@/lib/bookmark/types';
import type { WorkflowPreset } from './presets';
import { nanoid } from 'nanoid';

export function getMaxRootFolderOrder(
  folders: { readonly order: number }[]
): number {
  if (folders.length === 0) {
    return 0;
  }
  return Math.max(...folders.map((f) => f.order));
}

export function cloneBookmarkForSave(bookmark: Bookmark): Bookmark {
  return { ...bookmark, client_id: nanoid() };
}

export function cloneFolderTreeForSave(folder: Folder): Folder {
  return {
    ...folder,
    client_id: nanoid(),
    child_bookmarks: (folder.child_bookmarks ?? []).map(cloneBookmarkForSave),
    child_folders: (folder.child_folders ?? []).map(cloneFolderTreeForSave),
  };
}

export function workflowPresetToFolder(preset: WorkflowPreset): Folder {
  const {
    presetId: _presetId,
    description: _description,
    ...folderFields
  } = preset;
  return cloneFolderTreeForSave(folderFields as unknown as Folder);
}
